import CustomPaper from '../../containers/Paper'
import CustomButton from '../../components/Button'
import CustomModal from '../../containers/Modal'
import PostModal from '../../components/Modal/PostModal'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { PostDTO } from '../../models/post'
import PostService from '../../services/PostService'
import { useEffect, useState } from 'react'
import { Tab } from '../../components/Sidebar'
import { isAdmin } from '../../helpers/utils'
import Post from '../home/Post'
import NoResults from '../../containers/NoResults'
import { CircularProgress } from '@mui/material'

const tabs: Tab[] = [
    {
        label: 'Crear beneficio',
        icon: <AddCircleOutlineIcon />,
        id: 1,
    },
]

const BenefitsPage = () => {
    const [posts, setPosts] = useState<PostDTO[]>()
    const [isNewPostOpen, setIsNewPostOpen] = useState<boolean>(false)
    const [mutate, setMutate] = useState<boolean>(false)

    useEffect(() => {
        new PostService().getBenefits().then((response) => {
            setPosts(response.data)
        })
    }, [mutate])

    return (
        <div className="flex flex-col gap-4 w-full">
            {isAdmin() && (
                <>
                    {tabs.map((tab) => (
                        <CustomButton
                            key={tab.label}
                            text={tab.label}
                            onClick={() => setIsNewPostOpen(true)}
                            className={`w-full h-[36px] bg-secondary text-white`}
                            startIcon={tab.icon}
                            secondary
                        />
                    ))}
                </>
            )}
            {posts ? (
                posts.length > 0 ? (
                    posts.map((post) => (
                        <CustomPaper
                            id={post.id}
                            key={post.id}
                        >
                            <Post
                                info={post}
                                setMutate={setMutate}
                            />
                        </CustomPaper>
                    ))
                ) : (
                    <CustomPaper>
                        <NoResults
                            title="No se encontraron beneficios"
                            subtitle="Acá aparecerán los beneficios y promociones provistos por la universidad"
                        />
                    </CustomPaper>
                )
            ) : (
                <div className="flex w-full justify-center">
                    <CircularProgress
                        className="m-2 md:m-5 text-primary"
                        size={64}
                    />
                </div>
            )}
            <CustomModal
                isOpen={isNewPostOpen}
                handleClose={() => setIsNewPostOpen(false)}
            >
                <PostModal
                    handleClose={() => setIsNewPostOpen(false)}
                    setMutate={() => setMutate((prev) => !prev)}
                    isBenefit
                />
            </CustomModal>
        </div>
    )
}

export default BenefitsPage
